import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import routes from "../../constants/Routes";
import {getArrayFromObject, getBodyRegionsValueLabelObjectArray, isEmptyObject} from "../../utils/Utils";
import CONSTANT from "../../constants/Constant";
import Select, { components } from "react-select";
import Refresh from "../shared/Refresh";
import MmhTable from "../shared/table/datatable/MmhTable";
import Pagination from "../shared/Pagination";
import FysicalScoreReportView from "../report/FysicalScoreReportView";
import AppContext from "../../contexts/AppContext";
import GLOBAL from "../../global";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";
import examService from "../../services/ExamService";
import { format } from "date-fns";
// import viewReportBtn from "../../assets/img/list-page/my-assessment/viewReport.svg";
import viewReportBtn from "../../assets/img/myAssessmensList/eyeIcon.svg";
// import startExerciseDisableBtn from "../../assets/img/list-page/my-assessment/Start-Exercise-Disable.svg";
import startExerciseBtn from "../../assets/img/myAssessmensList/startExerciseBtn.svg";
// import dropdownBtn from "../../assets/img/mmh-table/dropDown.svg";
import MyExercisesDetails from "./MyExercisesDetails"
import MultipleSelectOption from "../my-assessments/MultipleSelectOption";
import MyAssessmentTooltip from "../my-assessments/MyAssessmentTooltip";
import ExerciseDetails from "./ExerciseDetails";
import AcademicCitationModal from "../shared/AcademicCitationModal";
import "../../assets/sass/components/my-exercises/_myExcercisesList.scss";

const MyExcercisesList = (props) => {
    const history = useHistory()
    let { testId } = useParams();
    const { showCompletedAssessments = false } = props
    const { userInfo } = useContext(AppContext);
    const { EnableFysicalScore, IsPatientReportAvailable } = userInfo.Permissions;
    const [assessments, setAssessments] = useState([]);
    const [fysicalReportView, setFysicalReportView] = useState(false);
    const [fysicalRportUrl, setFysicalRportUrl] = useState('');
    const [selectedExam, setSelectedExam] = useState({});
    const subscription = useRef(true);
    const [reloadMyRoms, setReloadMyRoms] = useState(false);
    const [filteredAssessments, setFilteredAssessments] = useState([]);
    const [reportFilterValue, setReportFilterValue] = useState(CONSTANT.FILTER_BY_REPORT.ALL.key);
    const [bodyRegions, setBodyRegions] = useState([]);

    // eslint-disable-next-line
    const [followUpFilterValue, setFollowUpFilterValue] = useState(CONSTANT.FOLLOW_UP.YES_OR_NO.key)
    const [myPageSize, setMyPageSize] = useState(CONSTANT.PAGE_SIZE.TEN.value);
    const [myPageNumber, setMyPageNumber] = useState(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
    const [totalRecord, setTotalRecord] = useState(0);
    const [loading, setLoading] = useState(true);
    const [reportStatus, setReportStatus] = useState(null);
    const [bodyRegionList, setBodyRegionList] = useState('');
    const [isFollowUp, setIsFollowUp] = useState(null);
    const firstTestIdRef = useRef(null);
    const [testIdTmp, setTestIdTmp] = useState('');
    const [showCitationModal, setShowCitationModal] = useState(false);
    const [selectedCitationTestId, setSelectedCitationTestId] = useState('');

    const { isSpinealignEnabled, isAcademicCitationEnabled } = useTenantFeatures();

    useEffect(() => {
        setLoading(true);
        // noinspection JSIgnoredPromiseFromCall

        // if(isEmptyObject(firstTestIdWithHomeExercise)) {
        //     getFirstExerciseTestId().then();
        // }
        _getMyAssessments();
        // eslint-disable-next-line
    }, [myPageNumber, myPageSize, reportStatus, bodyRegionList, isFollowUp]);

    useEffect(() => {
        // noinspection JSCheckFunctionSignatures
        setBodyRegions(getBodyRegionsValueLabelObjectArray());

        return () => {
            subscription.current = false;
            GLOBAL.ASSESSMENT = null;
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps,
    }, []);

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall

        if (reloadMyRoms) {
            _getMyAssessments().then();
            setReloadMyRoms(false);
        }
        // eslint-disable-next-line
    }, [reloadMyRoms]);

    // const getFirstExerciseTestId = async () => {
    //     setLoading(true);
    //     let payload = {
    //         // PatientId: patientId,
    //         PageSize: 10,
    //         PageNumber: 1,
    //         ReportStatus: null,
    //         BodyRegionList: [],
    //         IsFollowUp: null,
    //         Completed: false,
    //         Search: ``,
    //     };
    //
    //     const response = await examService.getAllMyExercises(payload);
    //     const {data, success, error} = response;
    //
    //     if (subscription.current) {
    //         if (!success) {
    //             console.log(error);
    //             return [];
    //         }
    //
    //         const tempData = data || '[]';
    //         if (tempData['MyRomList']?.length > 0 && myPageNumber === 1) {
    //             setFirstTestIdWithHomeExercise(tempData['MyRomList'][0]);
    //         }
    //     }
    //     setLoading(false);
    // }

    const _getMyAssessments = async () => {
        setLoading(true);
        let payload = {
            PageSize: myPageSize,
            PageNumber: myPageNumber,
            ReportStatus: reportStatus,
            BodyRegionList: bodyRegionList ? bodyRegionList.split`,`.map(x => +x) : [],
            IsFollowUp: isFollowUp,
            Completed: showCompletedAssessments,
            Search: `${testIdTmp}`,
        };

        const response = await examService.getAllMyExercises(payload);
        const { data, success, error } = response;

        if (subscription.current) {
            if (!success) {
                console.error(error);
                return [];
            }

            // const tempData = data || '[]';
            // setAssessments(tempData['MyRomList']);
            // setTotalRecord(tempData['TotalRecords']);
            const tempData = data || '[]';
            let romListExceptFirstOne = tempData['MyRomList'];
            let totalRomRecords = tempData['TotalRecords'];
            firstTestIdRef.current = tempData?.LatestTestId;
            // if(tempData['MyRomList']?.length > 0 && myPageNumber === 1) {
            //     romListExceptFirstOne = tempData['MyRomList'].slice(1);
            //     totalRomRecords = tempData['TotalRecords'] - 1;
            // }
            if(firstTestIdRef.current) {
                romListExceptFirstOne = tempData?.MyRomList.filter(item => item.TestId !== firstTestIdRef.current);
                totalRomRecords = totalRomRecords - 1 >= 0 ? totalRomRecords - 1 : 0;
            }

            // setAssessments(tempData['MyRomList']);
            // setTotalRecord(tempData['TotalRecords']);

            setAssessments(romListExceptFirstOne);
            setTotalRecord(totalRomRecords);

            commonFilter({
                data: romListExceptFirstOne,
                reportStatus: reportFilterValue,
                bodyRegions: []
            });

            setLoading(false);
        }
    };

    const onClickViewFysicalScoreReportCell = (row) => () => {
        if(!IsPatientReportAvailable) return;
        const { original } = row;
        const url = original['ReportUrl'];
        setFysicalRportUrl(url);
        toggleFysicalReportModal();
    };

    const onClickCitation = (testId) => {
        setSelectedCitationTestId(testId);
        setShowCitationModal(true);
    };

    const onHideCitationModal = () => {
        setShowCitationModal(false);
        setSelectedCitationTestId('');
    };

    const onClickTrackMovement = (row) => () => {
        GLOBAL.ASSESSMENT = null;
        const { original } = row;
        setSelectedExam(original);
        // setRedirectToMyExercises(true);
        history.push(`${routes.myExercises}/${original?.TestId}`)
        // window.location.replace(`/#${routes.myExercises}/${original?.TestId}`)
    }

    const toggleFysicalReportModal = () => {
        setFysicalReportView(!fysicalReportView);
    };

    const columns = useMemo(
        () => [
            {
                Header: 'Test ID',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    if(original['IsFollowUp']) {
                        return (
                            <div className="me-text-center">
                                <p className="me-m-0">FOLLOW-UP</p>
                                <p className="me-m-0">{original['TestId']}</p>
                                <p className="me-m-0 me-p-1 exercise-badge initial-testId">Initial: {original['BaseTestId']}</p>
                            </div>
                        )
                    } else {
                        return (
                            <div>
                                {original['TestId']}
                            </div>

                        )
                    }
                    // return `${original['IsFollowUp'] ? 'FOLLOW-UP ' + original['TestId'] : original['TestId']}`;
                }
            },
            {
                Header: 'Body Region',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return `${original['BodyRegionName']}`;
                }
            },
            {
                Header: 'Assessment',
                HeaderSecLine: 'Type',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return `${original['InvitationTypeTxt']}`;
                }
            },
            {
                Header: 'Order',
                HeaderSecLine: 'Date',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return format(new Date(original['SubmissionDate']) || new Date(), CONSTANT.DATE_FORMAT.MMM_DD_YYYY);
                }
            },
            {
                Header: 'Report',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;

                    return (
                        <>
                            {!original?.['ReportUrl']
                                ? (
                                    <span className="me-badge me-badge-warning font-medium font-size-sm color-black">In progress</span>
                                ) : (
                                    <>
                                    <button
                                        className={`me-btn me-button-row me-btn-border ${IsPatientReportAvailable ? '' : 'pointer-none opacity-0_4'}`}
                                        onClick={onClickViewFysicalScoreReportCell(cellProps.row)}>
                                         <span className="me-flex me-justify-center me-align-center">
                                            <i className="fa-regular fa-eye kt-mr-15"/> View Report
                                        </span>
                                    </button>
                                    {(isSpinealignEnabled && isAcademicCitationEnabled) && (
                                        <button
                                            className={`me-btn me-button-row me-btn-border ${IsPatientReportAvailable ? '' : 'pointer-none opacity-0_4'}`}
                                            onClick={() => onClickCitation(original?.TestId)}
                                            style={{ marginLeft: '10px' }}>
                                            <span className="me-flex me-justify-center me-align-center">
                                                Citation
                                            </span>
                                        </button>
                                    )}
                                    </>
                                )}
                        </>

                    );
                }
            },
            {
                Header: 'Home',
                HeaderSecLine: 'Exercises',
                style: 'w-100 text-center kt-align-center',
                Cell: (cellProps) => {
                    const { original } = cellProps.row;
                    return (
                        <>
                            {original['TotalHomeExercise'] === 0
                                ? (
                                    <span className="me-badge me-badge-warning font-medium font-size-sm color-black">Not Available</span>
                                )
                                : (
                                    <button
                                        className="me-btn me-pointer me-solid-button me-button-row"
                                         id={`home_exercise-${original['TestId']}`}
                                         onClick={onClickTrackMovement(cellProps.row)}
                                     >
                                        <i className="fa-solid fa-person-walking kt-mr-15"></i>
                                        Start
                                     <MyAssessmentTooltip text="Start Home Exercise" target={`home_exercise-${original['TestId']}`} />
                                     </button>
                                )
                            }
                        </>
                    );
                }
            }
        ],

        // eslint-disable-next-line
        []
    );

    const onChangeSelectBodyRegion = (values) => {
        const keys = values.map(item => item.value);

        if (values && values.length === 0) {
            setBodyRegionList('');
        }

        keys.map((key) => {
            if (!bodyRegionList.includes(key)) {
                if (bodyRegionList.length > 0) {
                    setBodyRegionList(bodyRegionList + ',' + key);
                } else {
                    setBodyRegionList(key + '');
                }
            }

            return null;
        });

        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
        setMyPageSize(CONSTANT.PAGE_SIZE.TEN.value);
    }

    const onKeyUpTestId = (e) => {
        e.preventDefault();
        setTestIdTmp(e.target.value);
        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
        setMyPageSize(CONSTANT.PAGE_SIZE.TEN.value);
        setReloadMyRoms(true);
    }

    const handlePageSize = (event) => {
        setMyPageSize(event.target.value);
        setMyPageNumber(CONSTANT.DEFAULT_PAGE_NUMBER.INITIAL_PAGE.value);
    }

    const handleRefresh = () => {
        setReloadMyRoms(true);
    }

    const getFilterByBodyRegionsData = (assessments, bodyRegionKeys) => {
        let filteredData = assessments;
        if (bodyRegionKeys?.length > 0) {
            filteredData = assessments.filter((item) => bodyRegionKeys?.includes(item?.BodyRegion));
            setFilteredAssessments(filteredAssessments);
        }

        return filteredData;
    }

    const getFilterByReportStatusData = (assessments, value) => {
        return assessments?.filter((item) => {
            if (value === CONSTANT.FILTER_BY_REPORT.IN_PROGRESS.key) {
                return !item?.['ReportUrl'];

            } else if (value === CONSTANT.FILTER_BY_REPORT.COMPLETED.key) {
                return item?.['ReportUrl'];

            } else {
                return true;
            }
        });
    }

    const getFilterByFollowUpData = (assessments, value) => {
        return assessments?.filter((item) => {
            if (value === CONSTANT.FOLLOW_UP.YES.key) {
                return item?.['IsFollowUp']

            } else if (value === CONSTANT.FOLLOW_UP.NO.key) {
                return !item?.['IsFollowUp']

            } else {
                return true;
            }
        });
    }

    const commonFilter = (
        {
            data,
            reportStatus = reportFilterValue,
            bodyRegions = [],
            followUp = followUpFilterValue
        }) => {
        // const filterByReportStatusData = getFilterByReportStatusData(data, reportStatus);
        // const filterByBodyRegions = getFilterByBodyRegionsData(filterByReportStatusData, bodyRegions);
        // const filterByFollowUp = getFilterByFollowUpData(filterByBodyRegions, followUp);

        //as already api filtering the data we do not need to filter those data again
        setFilteredAssessments(data);
    }

    return (
        <>


            {testId.startsWith(`TEST-`)
                ?
                    <MyExercisesDetails testId={testId || ""} />
                :
                    <>
                        {/*{(!loading && !isEmptyObject(firstTestIdWithHomeExercise))*/}
                        {/*    ? (*/}
                        {/*        <div className="d-flex flex-column w-100">*/}
                        {/*            <h3 className="my-3">Current Assigned Exercises</h3> ,*/}
                        {/*            <MyExercisesDetails testId={firstTestIdWithHomeExercise?.TestId} isFromMyExercisesTable={false} />*/}
                        {/*        </div>*/}
                        {/*    )*/}
                        {/*    :*/}
                        {/*    (*/}
                        {/*        <h3 className="my-3">Do Not Have Assigned Exercises</h3>*/}
                        {/*    )*/}
                        {/*}*/}

                        {(!loading
                            // && (!isEmptyObject(firstTestIdWithHomeExercise)
                            && (
                                firstTestIdRef.current
                                    ? (
                                        <div className="me-d-flex me-flex-column me-w-100">
                                            <h3 className="me-my-3 my-assessment-heading me-w-100">Current Assigned Exercises</h3> ,
                                            {/*<MyExercisesDetails testId={firstTestIdWithHomeExercise?.TestId} isFromMyExercisesTable={false} />*/}
                                            <MyExercisesDetails testId={firstTestIdRef.current} isFromMyExercisesTable={false} />
                                        </div>
                                    )
                                    :
                                    (
                                        <h3 className="me-my-3 me-w-100" style={{margin: '1rem 5rem',  color: 'var(--my-assessments-detail-color)'}}>Do Not Have Assigned Exercises</h3>
                                    )
                            )
                        )}

                        <h3 className="me-my-3 my-assessment-heading">Past Exercises</h3>

                        <div className="me-portlet color-primary font-wight-500 my-assessment me-w-100-percent">
                            <div className="me-portlet__body margin-bottom-3-rem">
                            <div className="filter-list display-flex justify-between">
                                <div className="display-flex gap-20px">
                                    {EnableFysicalScore && (
                                        <div className='filter-item'>
                                            <label htmlFor="example-text-input">Body Region</label>
                                            <MultipleSelectOption
                                                placeholder="Body Region"
                                                options={bodyRegions}
                                                onChange={onChangeSelectBodyRegion}
                                            />
                                        </div>
                                    )}
                                    <div className='filter-item'>
                                        <label
                                            htmlFor="example-text-input">TEST ID
                                        </label>
                                        <input
                                            placeholder="Test ID"
                                            className='filter_width_height select-option'
                                            onChange={e => setTestIdTmp(e.target.value)}
                                            onKeyUp={onKeyUpTestId}
                                        />
                                    </div>
                                </div>

                                <Refresh refreshFunction={handleRefresh}/>
                            </div>

                                <MmhTable columns={columns} data={filteredAssessments} loading={loading} section="my-exercises"/>

                                <div className="me-mt-3 table-pagination">
                                    <div className="table-pagination__page-number">
                                        <Pagination
                                            currentPage={myPageNumber}
                                            totalPages={Math.ceil(totalRecord / myPageSize)}
                                            onPageChange={(page) => {
                                                setMyPageNumber(page)
                                            }}
                                            pageRangeDisplayed={3}
                                            marginPagesDisplayed={2}
                                        />
                                    </div>
                                    <div className="table-pagination__quantity-in-a-page">
                                        <span className="table-pagination__info">Showing {((myPageNumber * myPageSize) - myPageSize) + 1} to {(myPageNumber * myPageSize)} of {totalRecord} entries</span>
                                        <select
                                            className="me-select me-select--small color-primary"
                                            onChange={handlePageSize}
                                            value={myPageSize}>
                                            {getArrayFromObject(CONSTANT.PAGE_SIZE)?.map((item, index) => {
                                                 return (
                                                     <option key={index} value={item.value}>
                                                         {item.name}
                                                     </option>
                                                 )
                                             })}
                                         </select>
                                     </div>
                                 </div>
                            </div>
                        </div>
                    </>
            }
            {fysicalReportView && (
                <FysicalScoreReportView
                    open={fysicalReportView}
                    url={fysicalRportUrl}
                    toggleFysicalReportModal={toggleFysicalReportModal}
                >
                </FysicalScoreReportView>
            )}
            <AcademicCitationModal
                show={showCitationModal}
                onHide={onHideCitationModal}
                testId={selectedCitationTestId}
            />
        </>
    )
}

export default MyExcercisesList;
